import getSelectedFolderViewState from 'owa-todos/lib/selectors/getSelectedFolderViewState';

export default function isBeingEdited(itemId: string): boolean {
    return getSelectedFolderViewState().currentEditingTodoId === itemId;
}
